import { adminStore } from '../stores';
import constant from '../utils/constant';
import { apiRequest } from '../utils/useAPIRequest';
import useFetcher from '../utils/useFetcher';

const login = async payload => {
	return await apiRequest({
		url: '/users/user/login',
		method: 'post',
		payload,
	});
};

const useGetOrdersAnalysis = () => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.getOrderAnalysis],
		url: '/orders/analysis',
	});
};

const useGetOrders = pageLimit => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.getOrders],
		url: '/orders',
		paginate: true,
		pageLimit: pageLimit,
	});
};

const useGetProducts = pageLimit => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.getProducts],
		url: '/fashion/styles',
		paginate: true,
		pageLimit: pageLimit,
	});
};

const updateOrderStatus = async (payload, query) => {
	const trackingStatus = payload.trackingStatus;
	const id = payload.id;
	const bId = adminStore.businessId;
	return await apiRequest({
		url: `/orders/order/${id}/${trackingStatus}?${query}&bId=${bId}`,
		method: 'put',
		payload,
	});
};

const useGetCollections = initialFilter => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.getCollections],
		url: '/fashion/collections',
		initialFilter,
	});
};

const createProduct = async payload => {
	return await apiRequest({
		url: '/fashion/new/style',
		method: 'post',
		payload,
	});
};

const editProduct = async (payload, id) => {
	return await apiRequest({
		url: `/fashion/new/style?styleId=${id}`,
		method: 'patch',
		payload,
	});
};

const deleteProduct = async id => {
	return await apiRequest({
		url: `/fashion/deactivate/${id}`,
		method: 'patch',
	});
};

const useGetBusinessDetails = () => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.getBusinessDetails],
		url: '/businesses/business-details',
	});
};

const updateSettings = async payload => {
	return await apiRequest({
		url: '/settings/update-setting',
		method: 'patch',
		payload,
	});
};

export const AdminController = {
	login,
	useGetOrdersAnalysis,
	useGetOrders,
	updateOrderStatus,
	useGetProducts,
	useGetCollections,
	createProduct,
	editProduct,
	deleteProduct,
	useGetBusinessDetails,
	updateSettings,
};
